import type { PortalData } from '../generated/api';
import config from '../config';
import LocalStorage from './LocalStorage';

export const PORTAL_DATA_KEY = 'portal-data';
const TTL = 1000 * 60 * 60 * 24 * 15; //15 days

function now() {
  return new Date().getTime();
}

async function warm() {
  console.log('WARMING UP portal-data');
  // An entry without tenant_id (cached from an unknown-host response) is
  // useless for the 15-day TTL — treat it as a miss and refetch.
  // const current = LocalStorage.get(LocalStorage.Keys.PortalData);
  // if (current && current.exp >= now() && current.tenant_id) {
  //   console.log('CACHE-HIT', current);
  //   return current;
  // }

  // console.log('CACHE-MISS');
  const url = `${config.PROTOCOL}://${config.API_URL}/api/portal-data?tenant_id=careand`;
  let data: PortalData;

  try {
    data = await (await fetch(url)).json();
  } catch (err) {
    console.log('WARMUP failed');
    return;
  }

  const exp = now() + TTL;
  LocalStorage.set(LocalStorage.Keys.PortalData, { ...data, exp });
  console.log('PORTAL-DATA', data);
  return data;
}

(window as any).careand_warmup = warm();

export const getPortalData = () => LocalStorage.get(LocalStorage.Keys.PortalData);
